import { Duration } from 'luxon'

export default function (value, customFormat = 'hh:mm:ss') {
  return Duration.fromObject({ seconds: value }).toFormat(customFormat)
}
